import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState,ListMutations, ListStateItem, ListModuleItem} from '@/store/shared'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

import DomesticSalesProfit from './entity'
import Tree from "@/store/shared/entity/tree";

interface DomesticSalesProfitState extends ListStateItem<DomesticSalesProfit>{
    editDomesticSalesProfit:DomesticSalesProfit,
}

class DomesticSalesProfitModule extends ListModuleItem<DomesticSalesProfitState,any,DomesticSalesProfit>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editDomesticSalesProfit:new DomesticSalesProfit(),
    }
    actions={
        async getAll(context:ActionContext<DomesticSalesProfitState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('services/app/DeclareCustoms/GetDomesticSalesProfitPage',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<DomesticSalesProfit>;
            context.state.table.totalCount=page.totalCount;
            page.items.push({shippingNumber:'',shipmentDate:null,shipmentDateStr:'合计',customerName:'',ownerName:'',businessGroup:'',factoryAmount:page.items.reduce((totalPrice, item) => totalPrice + item.factoryAmount, 0),invoiceTax:page.items.reduce((totalPrice, item) => totalPrice + item.invoiceTax, 0),amountReceivedRMB:page.items.reduce((totalPrice, item) => totalPrice + item.amountReceivedRMB, 0),bankCharges:page.items.reduce((totalPrice, item) => totalPrice + item.bankCharges, 0),profitType:'',profitMargin:null,remark:'',factoryName:null,id:null,profit:page.items.reduce((totalPrice, item) => totalPrice + item.profit, 0),freight:page.items.reduce((totalPrice, item) => totalPrice + item.freight, 0),receiverAmount:page.items.reduce((totalPrice, item) => totalPrice + item.receiverAmount, 0)})
            context.state.table.list=page.items;
        },
        //更新
        async update(context: ActionContext<DomesticSalesProfitState, any>, payload: any) {
            await $http.put('services/app/DeclareCustoms/UpdateDomesticSalesProfit', payload.data);
        },
    };
    overrideMutations={
        edit(state:DomesticSalesProfitState,domesticsalesprofit:DomesticSalesProfit){
            state.editDomesticSalesProfit=domesticsalesprofit;
        }
    }
}
const domesticSalesProfitModule=new DomesticSalesProfitModule();
export default domesticSalesProfitModule;